module.exports = __webpack_public_path__ + "img/grand-pool-3.7e49823d.jpg";